import SearchHighlight from "components/SearchHighlight";
import Link from "ds/components/Link";
import TextEllipsis from "ds/components/TextEllipsis";
import { TooltipProps } from "ds/components/Tooltip/types";
import Typography, { TypographyProps } from "ds/components/Typography";

type ListEntitiesItemLinkUrlProps = {
  href: string;
};

type ListEntitiesItemLinkProps = ListEntitiesItemLinkUrlProps & {
  title: string;
  titleTag?: TypographyProps["tag"];
  titleColor?: TypographyProps["color"];
  tooltip?: string;
  tooltipWidthMode?: TooltipProps["widthMode"];
  searchQuery?: string;
  onClick?: () => void;
};

const ListEntitiesItemLink = ({
  title,
  href,
  titleTag = "span",
  titleColor,
  tooltip = title,
  tooltipWidthMode = "maxWidthSm",
  searchQuery,
  onClick,
}: ListEntitiesItemLinkProps) => {
  return (
    <TextEllipsis tooltip={tooltip} tooltipWidthMode={tooltipWidthMode}>
      {(props) => (
        <Link variant="secondary" href={href} onPress={onClick}>
          <Typography {...props} variant="p-t7" tag={titleTag} color={titleColor}>
            {searchQuery ? <SearchHighlight fullText={title} searchQuery={searchQuery} /> : title}
          </Typography>
        </Link>
      )}
    </TextEllipsis>
  );
};

export default ListEntitiesItemLink;
